exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fbm-badge{color:#fff;padding:0 5px;background-color:#8a6f81}", ""]);

// exports
